import { createFileRoute } from '@tanstack/react-router';
import { OfficePreviewPage } from '@/features/office/preview/office-preview-page';

export const Route = createFileRoute('/dev/office-preview')({ component: OfficePreviewPage });
